import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint, Back } from 'gsap';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { Simulation } from '../../models/simulation';
import { InvestmentsSimulationEventType } from '../investments-simulation.event.type';
import { InvestmentsSimulationService } from '../investments-simulation.service';
import { EventTypes } from '../../../../shared/EventTypes';
import { Limit } from '../../../limits/models/limits';

@Component({
	selector: 'app-invest',
	templateUrl: './invest.component.html',
	styleUrls: ['./invest.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestComponent implements OnInit, OnDestroy {

	@Input() submited = false;

	// Recebe o array que contem todos os dados das etapas
	@Input() simulationData: Simulation;

	// Evento que sera disparado para enviar o form dessa etapa
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	form: FormGroup; // Cria o form dessa etapa

	dataLimits: Array<Limit>;

	view = '[data-component="invest"]'; // Componente dessa etapa

	active = true; // Verifica se o html da etapa atual deve ou nao ser exibido

	constructor(private formBuilder: FormBuilder, private investmentsSimulationService: InvestmentsSimulationService) {

		this.form = formBuilder.group({
			'investValue': ['', Validators.required]
		});

	}

	verifyZero() {
		if ($('.invest-value').val() === '0,00') {
			$('.invest-value').val('');
		}
	}

	ngOnInit() {

		AppEventDispatcher.listen(InvestmentsSimulationEventType.STEPS.INVEST, data => {
			if (data.show) {
				this.setForm.emit(this.form);
				this.loadLimits();
			} else {
				this.hide();
			}
		});

		AppEventDispatcher.listen(InvestmentsSimulationEventType.SEND.INVEST_SEND, data => {
			this.send();
		});
		
	}

	loadLimits() {
		this.preload(true);

		this.investmentsSimulationService.getDataLimits().subscribe( data => {
			data = data.filter((e) => {
				return e;
			});
			this.dataLimits = data;
			this.active = true;
			this.show();
			this.preload(false);

		}, error => {
			this.preload(false);

			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	show() {

		TweenMax.delayedCall(1, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
			this.verifyZero();
			TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	hide() {

		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(InvestmentsSimulationEventType.STEPS.INVESTMENTS_OPTIONS, {
				show: true, valueToInvest: this.form.controls.investValue.value});
			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});


	}

	setSimulationData() {
		// Adiciona os dados dessa etapa
		this.simulationData.investValue = this.form.controls.investValue.value;
	}

	send() {

		this.setSimulationData();
		this.preload(true);

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.investmentsSimulationService.getInvestmentsOptions(this.simulationData.investValue).subscribe( data => {
				if (data.length) {
					this.simulationData.investmentOptionsList = data;

					this.checkAfterSend(timeLoader, time);
				} else {
					this.checkAfterSend(timeLoader, time, 'Não foram encontradas opções de investimento para o período e valor informados.');
				}

		}, error => {

			this.checkAfterSend(timeLoader, time, error.Mensagem);

		});

	}

	checkAfterSend(timeLoader, time, error = null) {

		if (error) {
			AppEventDispatcher.dispatch(InvestmentsSimulationEventType.ERROR, { step: InvestmentsSimulationEventType.SEND.INVEST_SEND });
		}

		if (time > 3) {
			this.preload(false);
			if (error) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error });
			} else {
				this.hide();
			}
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
				if (error) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error });
				} else {
					this.hide();
				}
			});
		}
		clearInterval(timeLoader);
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.STEPS.INVEST);
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.SEND.INVEST_SEND);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="investments-simulation"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/invest/invest.component.ts